module.exports = "/_next/static/images/phone-send-cards-ef18d294ca4e7e14c20e232c008e3a01.jpg";